import { scrollMixin } from 'theme/MuiThemeProvider/mixins';
import { customTheme } from 'theme/MuiThemeProvider/theme';

export const styles = {
  menuWrap: {
    '& .MuiPaper-root': {
      minWidth: '280px',
      maxHeight: 'calc(100vh - 320px)',
      padding: '4px 0',
      borderRadius: '3px',
      boxShadow: '0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31)',
      ...scrollMixin,
    },
    '& .MuiMenu-list': {
      display: 'flex',
      flexDirection: 'column',
      padding: 0,
    },
  },
  menuButton: {
    minWidth: '80px',
    fontWeight: '400',
    color: customTheme.custom.black.B70,
    backgroundColor: customTheme.custom.black.B5,
    whiteSpace: 'nowrap',

    '&.MuiButton-containedPrimary': {
      ':hover': {
        backgroundColor: customTheme.palette.primary.P10,
      },
    },
  },
  menuButtonOpened: {
    color: customTheme.palette.primary.P100,
    backgroundColor: customTheme.palette.primary.P10,
  },
  selected: {
    color: customTheme.custom.black.B100,
  },
  menuButtonIcon: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3px',
    color: customTheme.custom.black.B100,
  },
  menuButtonIconopened: {
    color: customTheme.palette.primary.P100,
  },
  menuItemWrap: {
    margin: 0,
    padding: '6px 12px',

    '& .MuiFormControlLabel-label': {
      marginLeft: '8px',
      fontSize: '14px',
      color: customTheme.custom.black.B100,
    },
  },
  counter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    marginLeft: '4px',
    borderRadius: '50%',
    fontSize: '10px',
    color: customTheme.custom.white,
    backgroundColor: customTheme.palette.primary.P100,

    [`@media (max-width: 1320px)`]: {
      marginRight: '-4px',
    },
  },
  applyFilterWrap: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 12px 2px 6px',
  },
  applyFilterLabel: {
    fontSize: '10px',
    lineHeight: '21px',
    fontWeight: 400,
    color: customTheme.custom.black.B100,
  },
};
